import { generateJwtToken } from "../utils/api";

export const setAccessTypeUser = (email, mobile, id = null, name = null) =>
  generateJwtToken(email, id, name).then(token =>
    global.AccessType.setUser({
      emailAddress: email,
      mobileNumber: mobile,
      accesstypeJwt: token
    })
  );

export const logoutAccessTypeUser = () => global.AccessType.unsetUser();

export const getPlans = contributionId => {
  return global.AccessType.getSubscriptionPlans().then(list => {
    return list.filter(c => c.subscription_group_id === contributionId);
  });
};

export const getUserSubscriptions = () => global.AccessType.getSubscriptions();

export const getPaymentOptions = () => global.AccessType.getPaymentOptions();

// For Contribution Module
export const makeRazorpayPayment = (currentPlan, paymentOptions, data, customValue) => {
  // eslint-disable-next-line camelcase
  const { id, price_cents, price_currency, title, recurring } = currentPlan;

  // eslint-disable-next-line camelcase
  const inCents = currentPlan.recurring ? price_cents : customValue * 100;

  const subscriptionParams = {
    type: "standard",
    plan: {
      id,
      price_cents: inCents,
      price_currency,
      title
    },
    payment: {
      payment_type: recurring ? "razorpay_recurring" : "razorpay",
      amount_cents: inCents,
      amount_currency: price_currency
    },
    metadata: data
  };

  return paymentOptions.razorpay.proceed(subscriptionParams);
};

// For Subscribe NewsPaper Module
export const makeRazorpayPaymentNP = (currentPlan, paymentOptions, data) => {
  // eslint-disable-next-line camelcase
  const { id, price_cents, price_currency, title } = currentPlan;

  const subscriptionParams = {
    type: "standard",
    plan: {
      id,
      price_cents: price_cents,
      price_currency,
      title
    },
    payment: {
      payment_type: "razorpay",
      amount_cents: price_cents,
      amount_currency: price_currency
    },
    metadata: data
  };

  return paymentOptions.razorpay.proceed(subscriptionParams);
};

export const cancelUserSubscription = id => global.AccessType.cancelSubscription(id);

export const downloadInvoice = (subscriptionId, invoiceId) =>
  global.AccessType.downloadInvoice(subscriptionId, invoiceId).then(r => r.blob());

export const setAccessTypeNonLoggedInUser = email =>
  global.AccessType.setUser({
    emailAddress: email,
    isLoggedIn: false,
    accesstypeJwtUrl: null
  });
